class _3DRecord {
    name: string;

    filePath: string;

    constructor(name: string, filePath: string) {
        this.name = name;
        this.filePath = filePath;
    }
}

export default _3DRecord;